import { ApiError } from "./api";

const API_ERROR_LABELS: Record<string, string> = {
  already_member: "Diese Kostenstelle ist bereits zugeordnet.",
  cost_center_groupings_require_postgres:
    "Zugeordnete Kostenstellen sind in dieser Umgebung noch nicht aktiv.",
  cycle_or_two_level:
    "Diese Zuordnung würde eine zweite Ebene erzeugen. Erlaubt ist nur eine Ebene.",
  manual_cost_centers_require_postgres:
    "Manuelle Kostenstellen sind in dieser Umgebung noch nicht aktiv.",
  manual_project_not_found:
    "Das manuelle Projekt wurde nicht gefunden oder ist bereits archiviert.",
  manual_project_only:
    "Diese Kostenstellenart kann nicht manuell angelegt werden.",
  member_not_found: "Die ausgewählte Kostenstelle wurde nicht gefunden.",
  not_a_member: "Diese Zuordnung besteht nicht mehr.",
  parent_not_assignable:
    "Diese Kostenstellenart kann keine zugeordneten Kostenstellen halten.",
  parent_not_found: "Die übergeordnete Kostenstelle wurde nicht gefunden.",
  project_has_groupings:
    "Dieses Projekt hat noch Zuordnungen. Bestätige das Archivieren mit automatischem Lösen der Zuordnungen.",
  project_role_unchanged: "Diese Projektrolle ist bereits gespeichert.",
  self_reference: "Eine Kostenstelle kann nicht sich selbst zugeordnet werden.",
  unsupported_member_type: "Diese Kostenstellenart kann hier nicht zugeordnet werden.",
};

export function uiApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    return API_ERROR_LABELS[error.message] ?? readableErrorMessage(error.message, fallback);
  }
  if (error instanceof Error && error.message) {
    return readableErrorMessage(error.message, fallback);
  }
  return fallback;
}

function readableErrorMessage(message: string, fallback: string): string {
  const trimmed = message.trim();
  if (!trimmed) return fallback;
  const label = API_ERROR_LABELS[trimmed];
  if (label) return label;
  if (/^[a-z0-9_]+$/.test(trimmed)) return fallback;
  return trimmed;
}
